<div class="input-group">
  <input type="text" class="form-control" [attr.rt]="rt" (ngModelChange)="onInputChange($event)" [ngModel]="barcodeValue" (blur)="blur()" />
  <div class="input-group-append">
    <button class="btn btn-outline-gray" type="button" (click)="scannerStarted ? cancel() : start()">
      <i class="position-static position-static fs-28 text-green" [class.icon-scan]="!scannerStarted" [class.icon-close]="scannerStarted"></i>
    </button>
  </div>
</div>

<video *ngIf="scannerStarted" id="video" autoplay="true" class="b-light-grey"></video>
